module.exports = __webpack_public_path__ + "static/media/home4.fe6ea748.png";